import { BASE_URL } from "../common/const";
import { GET_ENC, POST_ENC } from "../common/EncryptedHttp";

export const GetMemberPhysicalGrowthDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/GrowthChart/GetDetail?` + params, null);

export const GetMemberPhysicalGrowthList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/GrowthChart/GetList?` + params, null);

export const CreateMemberPhysicalGrowth = (data: any) =>
    POST_ENC(`${BASE_URL}/api/GrowthChart/CreateMemberPhysicalGrowth`, data);

export const UpdateMemberPhysicalGrowth = (data: any) =>
    POST_ENC(`${BASE_URL}/api/GrowthChart/UpdateMemberPhysicalGrowth`, data);   

export const DeleteMemberPhysicalGrowth = (data: any) =>
    POST_ENC(`${BASE_URL}/api/GrowthChart/DeleteMemberPhysicalGrowth`, data);

export const GetGrowthChart = (params: any) =>
    GET_ENC(`${BASE_URL}/api/GrowthChart/GetGrowthChart?` + params, null);